import { Card, Button } from 'antd'
import styled from 'styled-components'

const Question = styled(Card)`
  box-shadow: 0 0 7px rgba(0,0,0,0.5);
  border: solid 2px black;
  border-radius: 5px;
`

const Choice = styled(Button)`
  height: 100% !important;
  border: solid 2px black;

  &.selected {
    border: solid 4px #1890ff;
  }
`

const QuestionText = styled.h5<{ count: number }>`
  font-family: 'Roboto Mono', monospace;
  font-weight: 700;
  font-size: ${props => props.count < 20 ? 6.5 : 135 / props.count }cqw;

  @media (min-width: 576px) {
    font-size: ${props => props.count < 20 ? 5 : 95 / props.count }cqw;
  }

  @media (min-width: 1200px) {
    font-size: ${props => props.count < 20 ? 4.5 : 85 / props.count }cqw;  
  }
`

const ChoiceText = styled.h6`
  font-family: 'Roboto Mono', monospace;
  font-weight: 700;
  font-size: 2.5rem;

  @media (min-width: 768px) {
    font-size: 1.5rem;
  }

  @media (min-width: 992px) {
    font-size: 2.0rem;
  }

  @media (min-width: 1200px) {
    font-size: 2.5rem;
  }
`

export { Question, Choice, QuestionText, ChoiceText }